import { render, staticRenderFns } from "./FaqsExpandable.vue?vue&type=template&id=e09c4cdc"
import script from "./FaqsExpandable.vue?vue&type=script&lang=js"
export * from "./FaqsExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports